import React from "react";
import { FormattedMessage } from "react-intl";
import { Card, Row, Space } from "@masterteam/mt-design-react";

import AsyncSvg from "../../AsyncSvg";
import useIsAr from "../../../Hooks/useIsAr";

import valueIcon from "../../../assets/images/values.svg";
import { ReactComponent as ValuesIcon } from "../../../assets/images/values.svg";

import styles from "./Values.module.scss";

const Values = ({ strategy }) => {
  const [isAr] = useIsAr();

  return (
    <Row size="large">
      <Card className={`${styles.container}`}>
        <Card className={styles.iconWrapper}>
          <ValuesIcon />
          <div className={styles.title}>
            <FormattedMessage id="strategy.values" />
          </div>
        </Card>

        <Space align="center" gap={36} className={styles.valuesWrapper}>
          {strategy?.Values?.map((item) => (
            <Space className={styles.valueWrapper} align="center" key={item.ID}>
              <div className={styles.valueIcon}>
                <AsyncSvg
                  defaultSvg={valueIcon}
                  attachment={item.Attachment}
                  color="var(--primary-color)"
                  style={{ width: 24, height: 24 }}
                />
              </div>

              <div className={styles.valueText}>
                {isAr ? item?.ArabicName : item?.EnglishName}
              </div>
            </Space>
          ))}
        </Space>
      </Card>
    </Row>
  );
};

export default Values;
